import {createAction} from '@reduxjs/toolkit'

export const updateFriends = createAction('friends/save', (data) => ({
  payload: data
}))
